// extracted by mini-css-extract-plugin
module.exports = {"dividers":"Dividers_dividers__2w2qc","divider":"Dividers_divider__1zb4-"};